import { render, staticRenderFns } from "./CommercantHeader.vue?vue&type=template&id=352d7e0b&scoped=true&"
import script from "./CommercantHeader.vue?vue&type=script&lang=js&"
export * from "./CommercantHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommercantHeader.vue?vue&type=style&index=0&id=352d7e0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d7e0b",
  null
  
)

export default component.exports